import { CustomCarousel } from "../../carousel/carousel";
import Modal from 'react-bootstrap/Modal';
import { Amenties, RoomInfoChip } from "../room/room";
import './room-detail-info-modal.scss';
import ImageGallery from "react-image-gallery";
import { AmentiesInfo } from "../rooms-info";
import Button from "react-bootstrap/esm/Button";

export function RoomDetailInfoModal({show, roomInfo, handleClose}) {
    const state = {
        showThumbnails : false,
        showBullets: true,
        showFullscreenButton: false, 
        showPlayButton: false,
        amentiesOverlay: false
    };
    const amenties = AmentiesInfo;

    return (
        <Modal show={show} onHide={() => handleClose(roomInfo)}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <div className="room-detail-info-modal">
                    <ImageGallery items={roomInfo.carouselImages} showThumbnails={state.showThumbnails}
                    showBullets = {state.showBullets} showPlayButton={state.showPlayButton} showFullscreenButton={state.showFullscreenButton}/>
                    <div className="room-detail-container">
                        <div className="room-detail">
                            <h5 className="margin-bot-1">{`${roomInfo.label} Room`}</h5>
                            <RoomInfoChip info={roomInfo}/>
                            <p> 
                                {roomInfo.description}
                            </p>
                            <div className="main-amenties">
                                <p className="font-0-8 bold-font font-red">Main Amenties:</p>
                                <AmentiesList amentiesList={amenties}/>
                            </div>
                        </div>
                        <div className="button-section">
                            <Button variant="primary" className='book-now'>Book Now</Button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
      </Modal>
    )
}
export function AmentiesList({amentiesList}){
    return(
        <div className='main-amenties'>
            <ul className='amenties'>
                {
                    amentiesList.map(
                        amenty => {
                            return <li className='amenty-item' key={amenty.id}>
                                <span className="amenty-item__label">
                                    <img className='amenty-icon' src={amenty.imageURL} alt={amenty.altText} loading="lazy" decoding="async"></img>
                                    <span className="amenty-label">{amenty.label}</span>
                                </span>
                            </li>
                        }
                    )
                }
            </ul>
        </div>
    )
}